import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


// WEBPACK FOOTER //
// ./src/store/index.js